import { LoadableLazy } from '@confluence/loadable';

export const AutomationOnboardingLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-lazy-AutomationOnboarding" */ '../src/AutomationOnBoarding'
			)
		).AutomationOnboarding,
});
